import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-alert-success",
  templateUrl: "./med-icon-alert-success.component.html",
})
export class MedIconAlertSuccessComponent extends SvgMixinComponent {}
